const state = {
	items: [],
	paging: {},
	item: {},
	cityList:[],
	staticCityList:[],
	cityPaging: {},
	singleCity: {},
}

const mutations = {
	// SET_USER_ITEMS: (state, payload) => {
	// 	console.log("herer >>> ", payload)
	// 	// state.items = payload.data;
	// 	// const pages = Object.assign(payload.pages, payload.items);
	// 	// state.paging = Object.assign({}, pages);
	// },
	// SET_USER_ITEM: (state, payload) => {
	// 	state.item = Object.assign({}, payload);
	// },
	SHOW_CITY_LIST: (state, payload) => {
		const { cityPaging, cityList } = payload;
		state.cityList = cityList;

		Object.assign(state.cityPaging, cityPaging)
	}
}

const actions = {
	setUserItems({ commit }, payload) {
		commit('SET_USER_ITEMS', payload)
	},
	setUserItem({ commit }, payload) {
		commit('SET_USER_ITEM', payload);
	},
	showCityList({ commit }, payload) {
		commit('SHOW_CITY_LIST', payload)
	},
}

const getters = {
	userItems: state => state.items,
	userPaging: state => state.paging,
	userItem: state => state.item,
	cityList: state => state.cityList
}

export default{
	state,
	mutations,
	actions,
	getters
}


// WEBPACK FOOTER //
// ./src/store/module/users.js